(function () {
  "use strict";

  // Progressive enhancement: without JS the viewport is a plain
  // horizontal scroll-snap strip (works with touch/trackpad). This
  // upgrades it to a transform-based slide — the track translates in
  // page steps with a CSS transition, and the prev/next buttons
  // disable at the ends.
  //
  // Below DESKTOP the CSS stacks the products into a vertical list, so
  // the slide logic sits out entirely (no transform, buttons hidden).
  var STEP = 2; // items advanced per click
  var DESKTOP = "(min-width: 640px)";

  function initCarousel(carousel) {
    if (carousel.dataset.carouselReady === "true") return;

    var viewport = carousel.querySelector("[data-carousel-viewport]");
    var track = carousel.querySelector("[data-carousel-track]");
    var prevBtn = carousel.querySelector("[data-carousel-prev]");
    var nextBtn = carousel.querySelector("[data-carousel-next]");
    if (!viewport || !track || !prevBtn || !nextBtn) return;

    var items = Array.prototype.slice.call(track.querySelectorAll("[data-carousel-item]"));
    if (!items.length) return;

    carousel.dataset.carouselReady = "true";
    carousel.classList.add("carousel--enhanced");

    var startIndex = 0;
    var desktop = window.matchMedia(DESKTOP);

    function gap() {
      var style = getComputedStyle(track);
      var value = parseFloat(style.columnGap || style.gap);
      return isNaN(value) ? 16 : value;
    }

    function step() {
      return items[0].getBoundingClientRect().width + gap();
    }

    function visibleCount() {
      var per = step();
      return per > 0 ? Math.max(1, Math.round(viewport.clientWidth / per)) : 1;
    }

    function maxStart() {
      return Math.max(items.length - visibleCount(), 0);
    }

    function apply() {
      if (!desktop.matches) {
        // Vertical list on mobile — CSS handles layout; clear any
        // transform left over from a desktop viewport.
        startIndex = 0;
        track.style.transform = "";
        return;
      }
      startIndex = Math.min(Math.max(startIndex, 0), maxStart());
      track.style.transform = "translateX(" + -(startIndex * step()) + "px)";
      prevBtn.disabled = startIndex <= 0;
      nextBtn.disabled = startIndex >= maxStart();
    }

    function slide(direction) {
      if (!desktop.matches) return;
      startIndex += direction * STEP;
      apply();
    }

    prevBtn.addEventListener("click", function () {
      slide(-1);
    });

    nextBtn.addEventListener("click", function () {
      slide(1);
    });

    var resizeRaf;
    window.addEventListener("resize", function () {
      if (resizeRaf) cancelAnimationFrame(resizeRaf);
      resizeRaf = requestAnimationFrame(apply);
    });

    apply();
  }

  function initAll(root) {
    (root || document).querySelectorAll("[data-carousel]").forEach(initCarousel);
  }

  initAll();

  // The theme editor swaps section markup without a full page reload.
  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
